import { render, staticRenderFns } from "./product-hero.vue?vue&type=template&id=0c6729dd&scoped=true"
import script from "./product-hero.vue?vue&type=script&lang=js"
export * from "./product-hero.vue?vue&type=script&lang=js"
import style0 from "./product-hero.vue?vue&type=style&index=0&id=0c6729dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6729dd",
  null
  
)

export default component.exports